// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"7e0c30c7","453":"3df807c1"}[chunkId] + ".chunk.js";
};